/* @flow */
import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Result } from 'antd';
import { AuthenticatedRoute } from '@/components';

interface Props {
  component: React$ComponentType<any>;
  props: Object;
}

export default function ProtectedRoute<C: React$ComponentType<Props>>({
  component: Component,
  props: cProps,
  ...rest
}: Props): React$Element<C> {
  if (
    (cProps.admin && !cProps.auth.permissions.superAdmin) ||
    (!cProps.auth.permissions.orgAdmin && !cProps.auth.permissions.superAdmin)
  ) {
    return (
      <Result
        status="error"
        title="Access Denied"
        subTitle="Sorry, you are not authorized to access this page."
        extra={
          <Button type="primary">
            <Link to="/manage/leads">Back To The Leads</Link>
          </Button>
        }
      />
    );
  }
  return <AuthenticatedRoute {...rest} props={cProps} component={Component} />;
}
